"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LoadingButton;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fa = _interopRequireDefault(require("./fa"));

var _reactstrap = require("reactstrap");

var _excluded = ["loading", "children", "disabled", "icon"];

function LoadingButton(_ref) {
  var loading = _ref.loading,
      children = _ref.children,
      disabled = _ref.disabled,
      icon = _ref.icon,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Button, (0, _extends2["default"])({}, rest, {
    disabled: loading || disabled
  }), !loading && icon && /*#__PURE__*/_react["default"].createElement(_fa["default"], {
    icon: icon,
    className: "mr-2"
  }), loading && /*#__PURE__*/_react["default"].createElement(_fa["default"], {
    icon: "spinner",
    spin: true,
    className: "mr-2"
  }), children ? children : "Continue");
}

LoadingButton.propTypes = {
  loading: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  icon: _propTypes["default"].string
};